module.exports = __webpack_public_path__ + "static/media/Bally_Backpack.ccc513b3.png";